// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  heroId: __t.u64().primaryKey().name("hero_id"),
  worldId: __t.u64().name("world_id"),
  picks: __t.array(__t.u16()),
  training: __t.byteArray(),
  talents: __t.array(__t.u16()),
  laurels: __t.array(__t.u16()),
});
